import { store } from './store'
import { useAppSelector, useAppDispatch } from './hooks';

export default store
export {
    useAppDispatch,
    useAppSelector
}
export * from './slices'